import { App } from 'vue'
import { trackView, trackClick, compressImage } from '@/utils'
import { Toast } from 'vant'

/**
 * 注册全局方法
 * @param app
 */
export function setupMethods(app: App) {
  app.config.globalProperties.$trackView = trackView
  app.config.globalProperties.$trackClick = trackClick
  app.config.globalProperties.$toast = Toast
  app.config.globalProperties.$compressImage = compressImage
}
